import { EventContentArg } from "@fullcalendar/core";
import { TimelineMasterWithEvent } from "../../../backoffice/dtos/timeline/timelineModel";
import EventPopOver from "./EventPopOver";
import InnerContent from "./InnerContent";

export function EventContent(arg: EventContentArg) {

    const event = arg.event.extendedProps as TimelineMasterWithEvent;

    if (!event)
        return <>
            Error, no promotion
        </>

    const id = `Tooltip-promotion_${event.event.id}`;
    return <>
        <InnerContent id={id} event={event}/>
        <EventPopOver target={id} event={event}/>
    </>
}
